var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8205 0H2.29437C1.33672 0 0.5 0.689062 0.5 1.63547V19.2C0.5 20.152 1.33672 21 2.29437 21H19.8153C20.7781 21 21.5 20.1469 21.5 19.2005V1.63547C21.5056 0.689062 20.7781 0 19.8205 0ZM12.0312 16.6406H7.17125L5.22266 4.98938L9.47656 4.58531L10.5078 12.8761C11.4702 11.3081 12.6584 8.84484 12.6584 7.16344C12.6584 6.24375 12.5009 5.61656 12.2548 5.10094L16.1281 4.31719C16.5763 5.05687 16.7778 5.81719 16.7778 6.78141C16.7773 9.85172 14.1566 13.8403 12.0312 16.6406Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.f15213f37c6fb81f33b8b0d0c667f01f.svg";
export { ForwardRef as ReactComponent };